import api from "./api.js";

export default class CommunityApi {
  static async getCategory(data) {
    return await api.get(`community-category`, data);
  }
  static async getCategoryById(id, data) {
    return await api.get(`community-category/${id}`, data);
  }
  static async addCategory(data) {
    return await api.post(`community-category`, data);
  }
  static async editCategory(id, data) {
    return await api.patch(`community-category/${id}`, data);
  }
  static async updateActivation(id, data) {
    return await api.patch(`community-category/activation/${id}`, data);
  }
  static async delcategory(data) {
    return await api.del(`community-category`, data);
  }
  static async changeCategory(id, data) {
    return await api.patch(`community-post/category/${id}`, data);
  }
  static async getPost(data) {
    return await api.get(`community-post`, data);
  }
  static async getPostById(id, data) {
    return await api.get(`community-post/${id}`, data);
  }
  static async delPost(data) {
    return await api.del(`community-post`, data);
  }
  static async getComment(data) {
    return await api.get(`community-comment`, data);
  }
  static async delComment(data) {
    return await api.del(`community-comment`, data);
  }
  static async getReport(data) {
    return await api.get(`community-report`, data);
  }
  static async getReportById(id, data) {
    return await api.get(`community-report/${id}`, data);
  }
  static async delReport(id) {
    return await api.del(`community-report/${id}`);
  }
}
